<template>
  <div v-if="item" class="relative w-full my-0.5 min-h-[12.5rem] border-[2px] border-[#F8B84E] rounded-[0.313rem] overflow-hidden">
    <!-- Ad flag -->
    <span class="absolute rtl:left-0 rtl:right-auto z-[10] top-2 py-0.5 px-1.5 sm:py-1 sm:px-2 md:py-1.5 md:px-3 left-auto right-0 bg-[#00000066] text-white text-[0.8rem] sm:text-[0.9rem] md:text-[1rem] font-bold rtl:rounded-[5px_0px] rounded-[0px_5px]">
        {{ $t('general.ad') }}
    </span>
    <!-- ad background -->
    <img :src="background || defaultImg" @error="onImageError" alt class="absolute inset-0 object-cover w-full h-full" />
    <!-- Store ad item inner -->
    <div class="flex flex-col pt-8 md:pt-3 pb-3.5 absolute z-0 px-5 before:absolute before:z-[-1] before:inset-0 w-full h-full before:bg-[#3030309c]" >
     <!-- store info -->
     <div class="flex flex-nowrap gap-3 self-start" >
       <!-- store image 1 -->
       <NuxtLink :to="storeLink" class="relative" :alt="item.name || 'unknown'" :aria-label="item.name || 'unknown'" :onclick="onClickStore">
        <!-- verification icon -->
         <img
             v-if="!!item.verified"
             src="data:image/svg+xml,%3csvg%20id='Layer_2'%20data-name='Layer%202'%20xmlns='http://www.w3.org/2000/svg'%20width='26.277'%20height='26.277'%20viewBox='0%200%2026.277%2026.277'%3e%3cpath%20id='Path_19717'%20data-name='Path%2019717'%20d='M3.678,7.77v8.18h7.148S17.238,11.9,17.458,11.6s5.527-1.032,1.4-3.832S15.984,4.822,14.29,4.822s-2.727-.59-3.906,0A58.737,58.737,0,0,1,4.71,6.664Z'%20transform='translate(0%201.932)'%20fill='%23fff'/%3e%3cpath%20id='Path_19330'%20data-name='Path%2019330'%20d='M13.138,2.029,9.62,0,7.664,3.387h-4.1V7.562L0,9.62l2.029,3.518L0,16.656l3.562,2.058V22.6H7.489L9.62,26.277l3.518-2.029,3.518,2.029L18.788,22.6h4.044V18.656l3.445-2-2.029-3.518L26.277,9.62l-3.445-2V3.387H18.613L16.656,0ZM18.014,9.4l1.46,1.46-7.489,7.606-4.5-4.555,1.46-1.46L11.97,15.43Z'%20fill='%230963ff'%20fill-rule='evenodd'/%3e%3c/svg%3e"
             class="absolute top-0 rtl:right-0 w-[1.2rem] h-[1.2rem]"
             width="19"
             height="19"
             alt="Verified Icon"
         />
         <!-- image -->
         <nuxt-img
             :src="item.logo"
             format="webp"
             @error="onImageError"
             class="w-[3.5rem] h-[3.5rem] object-cover rounded-full"
             :width="56"
             :height="56"
             alt="Logo"
         />
      </NuxtLink>
      <!-- store info -->
      <div :class="`${(+item.followers_count < 1 && +item.ratings_avg < 1) ? 'flex flex-col justify-center' : ''} text-white font-normal`.trim()">
        <NuxtLink :to="storeLink">
          <h3 class="text-[0.9rem] sm:text-[1rem] md:text-[1.1rem] font-semibold"> {{  item.name || 'unknown' }}</h3>
        </NuxtLink>
        <span v-if="+item.followers_count > 0" class="block text-[0.9rem] sm:text-[1rem] md:text-[1.1rem] mt-1">{{ $t('general.followers_count', {count: arabizeNumbers(Number(item.followers_count).toLocaleString())}) }}</span>
        <StarRating v-if="+item.ratings_avg > 0" :rating="+item.ratings_avg" sizesClass="mt-0.5 w-[1rem] h-[1rem] sm:w-[1.15rem] sm:h-[1.15rem] md:w-[1.3rem] md:h-[1.3rem]" />
      </div>
     </div>

     <!-- follow/unfollow button -->
     <div class="self-end mt-auto">
      <FollowUnfollowButton class="mt-2" appendedClass="w-full text-[1rem] py-2 px-6" :storeName="item?.name" :toggleFollowingState="toggleFollowingState" :followed="followed"
        :followingInProgress="followingInProgress" :designId="3" />
     </div>
    </div>
  </div>
</template>

<script>
import { onImageError, buildStoreLink, extractYouTubeId } from '@/helpers';
import defaultImg from "@/assets/images/placeholder(doNotRemove).jpg";
import StarRating from "@/components/generic/StarRating.vue";
import FollowUnfollowButton from "@/components/user/store/FollowUnfollowButton.vue";

export default {
    data(){
      return {
        defaultImg,
        followingInProgress: false,
        followed: 0
      }
    },
    props:{
      item: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },
    components: {
      StarRating,
      FollowUnfollowButton
    },
    computed:{
      isFollowing() {
        return !!this.item?.following;
      },
      storeLink(){
        return buildStoreLink(this.item?.username);
      },
      background(){
        return this.item.background_file_type === 'image' ? this.item.background_file : this.getYouTubeThumbnail(this.item.background_file);
      }
    },
    methods: {
      async onClickStore(){
        const model = 'store';
        const id = this.item.id;

        await this.makeRequest({
          url: `${this.APIREQUESTS.user.recordClick.url}/${model}/${id}`,
          method: this.APIREQUESTS.user.recordClick.method,
          includeUID: true
        }).then((res) => {
          if (!res?.status) {
          } else {
            // success
          }
        })
        .catch((err) => {
          //rejected
          console.log('err: ', err);
        });
      },
      getYouTubeThumbnail(youtubeURL) {
        return youtubeURL
          ? `http://img.youtube.com/vi/${extractYouTubeId(youtubeURL)}/0.jpg`
          : "";
      },
      onImageError,  
      setTheFollowingState ( isFollowed ) {
        this.followed = +isFollowed;
      },
      toggleFollowingState() {
            const { id } = this.item || {};
            const isOffline = !navigator.onLine;
            if (this.followingInProgress || !id || isOffline) {
                return;
            }
            this.followingInProgress = true;
           
            if(this.isUserLoggedIn){
              this.setTheFollowingState( !this.followed );
            }

            const bodyRequest = {
                store_id: id
            };
            
            this.makeRequest({
                owner: this.MAINROLES.user,
                url: this.APIREQUESTS.user.followStore.url,
                method: this.APIREQUESTS.user.followStore.method,
                formData: JSON.stringify(bodyRequest)
            })
                .then(res => {
                    if (!res?.status) {
                        this.setTheFollowingState( this.isFollowing );
                        // fail
                        this.notify({
                            type: "error",
                            msg: res?.message || this.$t("general.failed")
                        });
                    } else {
                        // success
                        this.setTheFollowingState( +res.data?.following);
                    }
                })
                .catch(err => {
                  // fail
                    this.setTheFollowingState( this.isFollowing );
                    // console.error(err);
                    this.notify({
                        type: "error",
                        msg:
                            (typeof err === "string" ? err : err?.data?.message) ||
                            this.$t("general.failed")
                    });
                })
                .finally(() => {
                    this.followingInProgress = false;
                });
        },
    },
    mounted(){
      this.setTheFollowingState(!!this.isFollowing );
    }
}
</script>

<style>

</style>